import { Component } from 'react'
import { Code, Participant, CodeableConcept, CodeableConcepts } from '../helpers'
import { FaRegCalendarCheck } from 'react-icons/fa'
import moment from 'moment'

import './resource.css'

class Appointment extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><FaRegCalendarCheck /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.serviceCategory && 'Category'}</div>
                            <div style={{ textAlign: 'right' }} className='Res-Title'>{this.props.resource.serviceCategory && CodeableConcepts(this.props.resource.serviceCategory)}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.serviceType && 'Service'}</div>
                            <div className='Res-Title'>{this.props.resource.serviceType && CodeableConcepts(this.props.resource.serviceType)}</div>
                        </div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.appointmentType && 'Appointment'}</div>
                            <div style={{ textAlign: 'right' }} className='Res-Title'>{this.props.resource.appointmentType && CodeableConcept(this.props.resource.appointmentType)}</div>
                        </div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.specialty && 'Specialty'}</div>
                        <div className='Res-Title'>{this.props.resource.specialty && CodeableConcepts(this.props.resource.specialty)}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.reasonCode && 'Reason'}</div>
                        <div className='Res-Title'>{this.props.resource.reasonCode && CodeableConcepts(this.props.resource.reasonCode)}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.description && 'Description'}</div>
                        <div className='Res-Title'>{this.props.resource.description && this.props.resource.description}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.start && 'Start'}</div>
                        <div className='Res-Title'>{this.props.resource.start && moment(this.props.resource.start).format('lll')}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.end && 'End'}</div>
                        <div className='Res-Title'>{this.props.resource.end && moment(this.props.resource.end).format('lll')}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.minutesDuration && 'Duration'}</div>
                        <div className='Res-Title'>{this.props.resource.minutesDuration && `${this.props.resource.minutesDuration} min`}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.created && 'Created'}</div>
                        <div className='Res-Title'>{this.props.resource.created && moment(this.props.resource.created).format('lll')}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.patientInstruction && 'Instructions'}</div>
                        <div className='Res-Title'>{this.props.resource.patientInstruction && this.props.resource.patientInstruction}</div>
                    </div>
                    {this.props.resource.participant && <div className='Res-Row'>{Participant(this.props.resource.participant)}</div>}
                </div>
            }
        </div></div>
    }
}

export default Appointment